export const pt_PT = require('@/assets/images/locale/pt-PT.png');
export const us_US = require('@/assets/images/locale/us-US.png');

export const logotipo = require('@/assets/images/portador/logotipo.png');
export const logotipo_dark = require('@/assets/images/portador/logotipo-dark.png');
export const Sidebar = require('@/assets/images/portador/SideBar.png');
export const logoSideBar = require('@/assets/images/portal/logo-sidebar.png');
export const trackingLogo = require('@/assets/images/portal/trackingPDLogo.png');
export const fullLogo = require('@/assets/images/portal/logo-login.png');
export const welcomeLogo = require('@/assets/images/portal/welcome-logo.svg');
